<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Uyguluma Takip Ekranı</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item">
                <a>Anasayfa</a>
              </router-link>
              <li class="breadcrumb-item active">Takip Ekranı</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                <div class="p-2">
                  Uygulamalar
                </div>
                <!-- notification class -->
                <div style="display: inline;">
                  <span ref="notificationsRef" type="text/css" class="ml-1">
                    <span class='ml-2 mr-2 p-2' style='background-color: rgba(190, 30, 30, 0.680); '> Loading ... </span>
                  </span>
                </div>
                <button class="btn btn-primary btn-sm float-right" @click="addApp"
                  v-if="auth.AppWatch != null && auth.AppWatch.isWrite">
                  <i class="fas fa-plus"></i> Yeni Uygulama Aç
                </button>
                <button class="btn btn-outline-primary btn-sm float-right" @click="resetPage" style="margin-right: 10px">
                  <i class="fas fa-sync-alt"></i> Sayfayı Yenile
                </button>
              </div>
              <div class="card-body table-responsive p-0">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th style="width: 1%">#</th>
                        <th>Uygulama Adı</th>
                        <th>Uygulama Durumu</th>
                        <th>Bekleyen Talep Sayısı</th>
                        <th>Son Çalışma Zamanı</th>

                        <th style="min-width: 300px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in datatable" :key="item.id">
                        <td>#</td>
                        <td>
                          <a>{{ item.name }}</a>
                        </td>
                        <td>
                          {{
                            !item.isComplate && !item.isReset && !item.isPause
                            ? "Başlatılıyor"
                            : ""
                          }}
                          {{
                            item.isComplate && !item.isReset && !item.isPause
                            ? "Çalışıyor"
                            : ""
                          }}
                          {{
                            item.isComplate && item.isReset
                            ? "Yeniden Başlatılıyor"
                            : ""
                          }}
                          {{
                            item.isComplate && item.isPause ? "Durduruldu" : ""
                          }}
                        </td>
                        <td>
                          <span v-if="item.total > 0"><strong>Bekleyen {{ item.total }} Talep</strong></span>
                          <span v-if="item.total == 0">Bekleyen Talep Yok</span>
                        </td>
                        <td>
                          <span :class="{ changed: item.isChange }">
                            {{ item.pingDate | DateFormat }}</span>
                        </td>

                        <td class="project-actions text-right">
                          <router-link tag="button" :to="'/watch/logs/' + item.id" class="btn btn-outline-primary btn-sm"
                            v-if="item.isComplate">
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <button class="btn btn-outline-info btn-sm" @click="getProcess(item.id)" v-if="auth.AppWatch != null && auth.AppWatch.isWrite
                            ">
                            <i class="fas fa-cogs"></i>
                          </button>

                          <button class="btn btn-outline-danger btn-sm" @click="del(item.id)" v-if="item.isComplate &&
                            !item.isProcess &&
                            auth.AppWatch != null &&
                            auth.AppWatch.isWrite
                            ">
                            <i class="fas fa-stop"></i>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center" colspan="6" v-if="datatable.length == 0">
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="perPage" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->

    <!--Modal-->
    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Uygulama Başlat</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Uygulama Seçiniz</label>
                <select @blur="$v.add.app.$touch()" v-model="$v.add.app.$model" class="form-control"
                  :class="{ 'is-invalid': $v.add.app.$error }">
                  <option :value="null">Uygulama Seçiniz</option>
                  <option v-for="item in apps" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                </select>
                <small v-if="!$v.add.app.required && $v.add.app.$error" class="form-text text-danger">Bu alan
                  zorunludur...</small>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button type="button" class="btn btn-primary" @click="save()" :disabled="$v.add.$invalid">
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="modal-process">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Uygulama İşelm Emirleri</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>İşlem</th>
                  <th>İstek Zamanı</th>
                  <th>Sonuç Zamanı</th>
                  <th>Sonuç</th>
                </tr>
              </thead>
              <thead>
                <tr v-for="item in process" :key="item.id">
                  <td>
                    {{ item.type == 1 ? "Uygulamayı Başlat" : "" }}
                    {{ item.type == 2 ? "Uygulamayı Kapat" : "" }}
                    {{ item.type == 3 ? "Yeniden Başlat" : "" }}
                    {{ item.type == 4 ? "Duraklat / Başlat" : "" }}
                  </td>
                  <td>{{ item.date | DateFormat }}</td>
                  <td>{{ item.complateDate | DateFormat }}</td>
                  <td>
                    {{
                      item.isError
                      ? item.errorMessage
                      : item.isComplate
                        ? "Tamamlandı"
                        : "Devam Ediyor"
                    }}
                  </td>
                </tr>
                <tr v-if="process.length == 0">
                  <td class="text-center" colspan="4">Kayıt Bulunamadı</td>
                </tr>
              </thead>
            </table>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      auth: this.$store.getters.getModules,
      service: this.$store.getters.getHub,
      page: 1,
      perPage: 10,
      rows: 0,
      datas: [],
      datatable: [],
      process: [],
      apps: [],
      overlay: false,
      add: {
        app: null
      },
      ping: {}
    };
  },
  validations: {
    add: {
      app: {
        required
      }
    }
  },
  methods: {
    pagination(value) {
      var count = (value - 1) * this.perPage;
      this.datatable = this.datas.slice(count, count + this.perPage);
    },
    getApps() {
      this.overlay = true;
      this.$http.get("App/ListActiveApps").then(response => {
        this.apps = response.data;
        this.overlay = false;
      });
    },
    getProcess(id) {
      this.$http.get("Process/ListAppProcess/" + id).then(response => {
        this.process = response.data;
        $("#modal-process").modal();
      });
    },
    addApp() {
      this.add = {
        app: null
      };
      this.$v.$reset();
      $("#modal").modal();
    },
    resetPage() {
      this.page = 1;
      this.$store.dispatch("getBotListService");
    },
    resetApp(id) {
      this.$http.get("AppProcess/ResetAppProcess/" + id).then(
        response => {
          toastr.success("İsteğiniz işleme alındı.");
          this.$store.dispatch("getAppList");
        },
        error => {
          toastr.error(error.data.Message);
        }
      );
    },
    calculateNotifications(apps) {
      const spanElement = this.$refs.notificationsRef;
      var _notificaitonsApp = "Belirtilen uygulama/uygulamalar için son ping zamanı 5 dakika üzerindedir. Kontrol edilmesi gereken uygulamalar : ";
      var _Apps = [];
      apps.forEach(element => {
        if (element.pingDate) {
          if (new Date(element.pingDate) < (new Date(new Date() - 5 * 60 * 1000))) {
            _Apps.push(element.name);
          }
        }
        else {
          _Apps.push(element.name);
        }

      });
      if (_Apps.length > 0) {
        spanElement.innerHTML = `<span class='mb-4 mr-2' '> ${_notificaitonsApp + _Apps.join(", ")
          } </span > `;
        spanElement.setAttribute("style", "background-color: rgba(190, 30, 30, 0.680);display: inline-block; max-width: 64vw;");
      } else {
        spanElement.innerHTML = `<span class='ml-2 p-2''> Tüm botları işlem sağlamaktadır. Bu bildirim her 30 saniyede bir kendini yenilemektedir bilginize. </span > `;
        spanElement.setAttribute("style", "background-color: rgba(69, 180, 69, 0.680);;display: inline-block; max-width: 64vw;");
      }

    },
    save() {
      this.$http.get("AppProcess/AddAppProcess/" + this.add.app).then(
        response => {
          toastr.success("Kayıt başarılı.");
          $("#modal").modal("hide");
          this.$store.dispatch("getAppList");
        },
        error => {
          toastr.error(error.data.Message);
        }
      );
    },
    status(id, status) {
      this.$http.get("AppProcess/PauseAppProcess/" + id).then(
        response => {
          toastr.success("İsteğiniz işleme alındı.");
          this.$store.dispatch("getAppList");
        },
        error => {
          toastr.error(error.data.Message);
        }
      );
    },
    del(id) {
      Swal.fire({
        title: "Uygulama kapatılacak! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Kapatılsın",
        cancelButtonText: "İptal",
        icon: "question"
      }).then(result => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$http.get("AppProcess/CloseAppProcess/" + id).then(
            response => {
              toastr.success("Uygulama kapatma isteği işleme alındı");
              this.$store.dispatch("getAppList");
            },
            error => {
              toastr.error(error.data.Message);
            }
          );
        }
      });

      return;
    }
  },
  computed: {
    getAppList() {
      this.datas = this.$store.getters.getAppListData;
      this.rows = this.datas.length;

      return this.datas;
    }
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    }
  },
  created() {
    this.getApps();
    this.$store.dispatch("getBotListService");
  },
  beforeDestroy() { },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
    "$store.getters.getBotList"() {
      this.datas = this.$store.getters.getBotList;
      this.rows = this.datas.length;
      const count = (this.page - 1) * this.perPage;
      this.datatable = this.datas.slice(count, count + this.perPage);
      this.calculateNotifications(this.datas.slice());
    }
  }
};
</script>
<style scoped>
.changed {
  font-weight: 700;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.highlight {
  background-color: rgba(190, 30, 30, 0.680) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Watch/WatchList.vue